export function extractAccountGroupIdFromRoute(route: string): string {
  const locationPattern = /\/account\/location\/([^/]+)/;
  const locationMatch = locationPattern.exec(route);
  if (locationMatch && locationMatch.length > 1) {
    return locationMatch[1];
  }

  const brandPattern = /\/account\/brands\/[A-Z0-9-]*\/[a-z]*\/(AG-[A-Z0-9-]*)\/[A-Za-z0-9-/]*/;
  const brandMatch = brandPattern.exec(route);
  if (brandMatch && brandMatch.length > 1) {
    return brandMatch[1];
  }

  return '';
}
